var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.dummy
    ? _c(
        "span",
        {
          class: `pix-member-circle ${
            _vm.clickable && !_vm.dummy ? "pix-member-circle--clickable" : ""
          }`,
          attrs: { title: _vm.formattedName },
          on: { click: _vm.emitClick },
        },
        [_c("span", [_vm._v(_vm._s(_vm.initials))])]
      )
    : _c(
        "span",
        {
          class: `pix-member-circle ${
            _vm.clickable && !_vm.dummy ? "pix-member-circle--clickable" : ""
          }`,
          attrs: { title: _vm.formattedName },
          on: { click: _vm.emitClick },
        },
        [_c("span", [_vm._v(_vm._s(_vm.dummyText))])]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }